import React from "react";

const Summary = ({ summary }) => {
  return <p>{summary}</p>;
};

export default Summary;
